var BaseViews = require('../base');
require('./order-complete/order-complete.scss');

var OrderComplete = BaseViews.LayoutView.extend({
    className: 'fmcy-order-complete',
    template: require('./order-complete/order-complete.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light',
                orderId: 0,
                order: null,
                location: null
            }
        );
    },
    serializeData: function () {
      if (this.options.order.order_delivery_method == 'pickup') {
        return {
          deliveryMethod: this.options.order.order_delivery_method,
          orderId: this.options.orderId,
          hours: this.options.location.get('hours_readable'),
          locationName: this.options.location.get('name')
        }
      } else {
        return {
          deliveryAddress: this.options.order.order_local_delivery_street_address,
          deliveryMethod: this.options.order.order_delivery_method,
          deliveryDate: this.options.order.order_delivery_date,
          deliveryTime: this.options.order.order_delivery_time,
          deliveryTimeReadable: this.options.order.order_delivery_time_readable,
          deliveryWindowMinutes: this.options.order.order_delivery_window_minutes,
          orderId: this.options.orderId,
          hours: this.options.location.get('hours_readable'),
          locationName: this.options.location.get('name')
        }
      }
    },
    onRender: function() {
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
      this._onWindowResize();
      Backbone.Radio.channel('global').request(
          'request:notifications:permission'
      );
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    _onWindowResize: function (event) {
      var magicBuffer = 117;
      var minHeight = $(window).height() - magicBuffer;
      this.$el.css('minHeight', minHeight);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});

module.exports = OrderComplete;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/order-complete.js
 **/